<section class="wrapper">
    <div class="header-section" style="box-shadow: 3px 3px 6px rgba(0,0,0,0.35);">

        <label>Patient:</label>

        <input type="text" class="header-input" style="width: 120px;background-color: white;" maxlength="8" [(ngModel)]="Patientcode" (change)="Retrive_All()">

        <span class="fa fa-search search-icon" (click)="OpenPatientDialog()"></span>

        <label class="header-input" style="width: 240px;">
      {{Patientname}}
    </label>

        <label>Age:</label>
        <label class="header-input" style="width: 20px;">{{paAge}}</label>
        <label>Years</label>

        <label style="margin-left: 20px;">Consultant:</label>
        <label class="header-input" style="width: 277px;">{{doctorname}}</label>

        <a target="_blank" (click)="RoundAndClinicOpen()">
            <button class="icon-btn fa fa-hospital-o" matTooltip="Rounds and Clinic" matTooltipClass="bigTooltip">
</button> </a>

        <a href="PreparationOrderNew" target="_blank" (click)="OpenPreparation()">
            <button class="icon-btn fa fa-medkit" matTooltip="Clinical pharmacy" matTooltipClass="bigTooltip">
</button> </a>
        <button class="icon-btn fa fa-info" (click)="PatientInfo()" matTooltip="Patient Info" matTooltipClass="bigTooltip"></button>

    </div>

    <div class="header-section" style="box-shadow: 3px 3px 6px rgba(0,0,0,0.35);">

        <label>Gender:</label>
        <label class="header-input" style="width: 80px;">{{gender}}</label>

        <label>Date of 1st. Visit:</label>
        <label class="header-input" style="width: 180px;">{{dateEntry1}}</label>

        <label>Cancer Type:</label>
        <select [(ngModel)]="cancerID" class="header-input" style="width: 400px;">
      <option *ngFor="let Canc of cancerlist" [value]="Canc.cancerID">
        {{Canc.cancerName}}
      </option>
    </select>


    </div>
</section>


<div style="position: absolute;width: 60%;left: 20%;align-items: center;">
    <mat-accordion class="example-headers-align" multi style="width: 100%;">
        <!--************* Diganosis **********-->
        <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-user-md" aria-hidden="true">
                    {{'Key Pathology/Biology features' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>


            <div style="height: 200%; max-height: 400px; overflow-y: auto;">
                <app-diganostic-tab></app-diganostic-tab>
            </div>
        </mat-expansion-panel>
        <mat-divider></mat-divider>
        <!--************* Progress Note **********-->
        <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-tasks" aria-hidden="true">
                    {{'Progress Notes' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="height: 200%; max-height: 400px; overflow-y: auto;">
                <app-progress-note-tab></app-progress-note-tab>
            </div>
        </mat-expansion-panel>
        <mat-divider></mat-divider>
        <!--************* Clinical Exams **********-->
        <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-heartbeat" aria-hidden="true"> {{'Clinical Examination' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div style="height: 200%; max-height: 400px; overflow-y: auto;width: 100%;">
                <app-clinical-exam-tab></app-clinical-exam-tab>
            </div>
        </mat-expansion-panel>
        <mat-divider></mat-divider>
        <!--************* Aniti Cancer Treatment **********-->
        <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-hospital-o" aria-hidden="true">  {{'Treatment at Cairo Cure' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="height: 200%; max-height: 400px; overflow-y: auto;width: 90%;">
                <app-anti-cancer-treatment-tab></app-anti-cancer-treatment-tab>
            </div>
        </mat-expansion-panel>
        <mat-divider></mat-divider>
        <!--************* Decision/Next steps **********-->
        <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-handshake-o" aria-hidden="true">
                    {{'Decisions/Next steps' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="height: 200%; max-height: 400px; overflow-y: auto;width: 100%;">
                <app-decision-tab></app-decision-tab>
            </div>
        </mat-expansion-panel>
        <mat-divider></mat-divider>
        <!--************* Other Clinic **********-->
        <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-handshake-o" aria-hidden="true">
                    {{'Multidisciplinary Clinics' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="height: 200%; max-height: 400px; overflow-y: auto;width: 100%;">
                <app-other-clinic-tab></app-other-clinic-tab>
            </div>
        </mat-expansion-panel>
        <mat-divider></mat-divider>
        <!--********** Nursing Assessments **********-->
        <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-thermometer-empty" aria-hidden="true">
                    {{'Nursing Assessments' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="width: 90%;">
                <app-nursing-assessment-tab></app-nursing-assessment-tab>
            </div>

        </mat-expansion-panel>
        <mat-divider></mat-divider>
        <!--********** Non Cancer Medication **********-->
        <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-ambulance" aria-hidden="true">
                    {{'Non Cancer Medical History' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="width: 100%;">
                <app-medical-history-vtab></app-medical-history-vtab>
            </div>

        </mat-expansion-panel>
        <mat-divider></mat-divider>
        <!--********** Family History **********-->
        <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title style="width:100%;height: 50px; font-size: 130%; background-color: #143d7b;color: white;padding-top: 10px;padding-left: 10px;text-align: center;" class="fa fa-wheelchair-alt" aria-hidden="true">
                    {{'Cancer Family History' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    <mat-icon></mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="width: 100%;">

                <app-family-history></app-family-history>
            </div>

        </mat-expansion-panel>

    </mat-accordion>
    <mat-divider></mat-divider>
    <Br>
    <BR>

    <div style="position: absolute;width: 90%;text-align: center;font-weight: bold;">
        <a href="PatientDocumentNew" target="_blank">
            <button type="button" class="theme-button btn" (click)="PutPatient()" style="background-color: rgb(0, 0, 61);color: white;width: 30%;border-style: none;" name="submit">Patient Doc.</button>
        </a>
        <a href="annex" target="_blank">

            <button type="button" class="theme-button btn" style="background-color: rgb(1, 48, 28);color: white;width: 30%;border-style: none;" name="Delete">Annex</button>
        </a>
        <a href="PatientReservation" class="drop-text">

            <button type="button" class="theme-button btn" style="background-color: rgb(158, 0, 0);color: white;width: 30%;border-style: none;" name="rep" name="rep">Exit</button>
        </a>
    </div>
</div>
<section class="wrapper" style="max-width: 1785px;">
    <div>

    </div>
</section>
